import { useOverlays } from "contexts/OverlayContext";
import { PostConnectAssignmentModal } from "./PostConnectAssignmentModal";

export const PostConnectAssignmentOverlay = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("organizationPostConnectAssignment");

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <PostConnectAssignmentModal
            key={overlayInfo.instanceId}
            organizationId={overlayInfo.data.organizationId}
            connectionId={overlayInfo.data.connectionId}
            show={!overlayIsClosing}
            onClose={closeOverlay}
        />
    );
};
